import { render, staticRenderFns } from "./ModalImportarAtracoesArtisticas.vue?vue&type=template&id=7853ca1c&scoped=true"
import script from "./ModalImportarAtracoesArtisticas.vue?vue&type=script&lang=ts"
export * from "./ModalImportarAtracoesArtisticas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7853ca1c",
  null
  
)

export default component.exports